import Style from "./MessageTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";

import React, { useState, useEffect } from "react";
import PageTitle from "../../components/PageTitle";

export default function MessagesTable(props) {

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([] as any);
  const [anyMessageAddress, setAnyMessageAddress] = useState(false);


  const [showNewChat, setShowNewChat] = useState(false);
  const [companyUsers, setCompanyUsers] = useState([] as any);
  const [loadingCompanyUsers, setLoadingCompanyUsers] = useState(false);


  useEffect(() => {
    GetMessagesList().then(() => setLoading(false));
    const updateMessageIntervalID = setInterval(GetMessagesList, 10000);

    return () => {
      console.log("Parando atualização das mensagens");
      clearInterval(updateMessageIntervalID);
    }
  }, []);


  async function GetMessagesList() {
    try {
      const result = await api.get(`/messages/list`);
      const messages = result.data.messages;
      setMessages(messages);
      const anyMessage = messages.some(message => message.documentId);
      setAnyMessageAddress(anyMessage);
    }
    catch (error) {
      console.error(error);
    }
  }

  function GoToUserChat(userId: number) {
    props.history.push(`/messages/${userId}`);
  }

  function GoToSendMessageToAll() {
    props.history.push(`/messages/toAll`);
  }

  function GoToSendMessageToGroups() {
    props.history.push(`/messages/toGroups`);
  }

  async function OnClickNewChat() {
    setShowNewChat(true);
    if (companyUsers?.length === 0) {
      try {
        setLoadingCompanyUsers(true);
        const result = await api.get("/companies/users");
        setCompanyUsers(result.data.users.sort(Compare));
        setLoadingCompanyUsers(false);
        console.log("Terminou de pegar");
      }
      catch (error) {
        setLoadingCompanyUsers(false);
      }
    }
  }

  function Compare(a, b) {
    if (a.name === b.name)
      return a.id > b.id ? 1 : -1;

    return a.name > b.name ? 1 : -1;
  }

  return (
    <Style>
      <PageTitle title="Mensagens" />
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Mensagens</h1>
        <div id="functionButtons">
          <button onClick={GoToSendMessageToGroups}>Enviar para grupos</button>
          <button onClick={GoToSendMessageToAll}>Enviar para todos</button>
          <button onClick={OnClickNewChat}>Nova conversa</button>
        </div>

      </section>

      {showNewChat &&
        <div id="new-chat">
          <div id="new-chat-title">
            <button onClick={() => setShowNewChat(false)}>Voltar</button>
            <h1>Nova conversa</h1>
          </div>

          <Spinner spinning={loadingCompanyUsers} />
          <ul>
            {companyUsers.map(user => {
              return (<li onClick={() => GoToUserChat(user.id)} key={user.id}>{user.name}</li>)
            })}
          </ul>
        </div>
      }

      {!showNewChat &&
        <table className="table table-striped table-bordered table-hover main-table">
          <thead >
            <tr>
              <th>Usuário</th>
              {
                ///TODO: Gambi: Pegar das configurações
                anyMessageAddress &&
                <th>Unidade</th>
              }
              <th>Mensagem</th>
              <th>Foi visto</th>
              <th>Enviado por</th>
              <th>Data de Envio</th>
            </tr>
          </thead>
          <tbody>
            {messages?.length > 0 && messages.map(message => {
              return (
                <tr key={message.userId} onClick={() => GoToUserChat(message.userId)} className="clickable">
                  <td>{message.name}</td>
                  {
                    ///TODO: Gambi: Pegar das configurações
                    anyMessageAddress &&
                    <td>{message.documentId || "Sem dados da unidade"}</td>
                  }
                  <td>{message.attachmentName ? `Arquivo enviado: ${message.attachmentName}` : message.message}</td>
                  <td>{message.read ? "Lido" : "Não lido"}</td>
                  <td>{message.userSent ? "Usuário" : "Empresa"}</td>
                  <td>{new Date(message.date).toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      }
    </Style >

  )
}